import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <circle cx="7.67153" cy="7.67153" r="6.17153" stroke="currentColor" />
    <path
      d="M5.38469 8.81537C6.24246 10.5786 9.14934 10.6739 10.0071 8.81537"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path d="M5.57527 5.9563L5.76589 5.9563" stroke="currentColor" strokeLinecap="round" />
    <path d="M9.57886 5.9563L9.76947 5.9563" stroke="currentColor" strokeLinecap="round" />
  </svg>
);
